import { Box, Heading, Stack, SimpleGrid, Link as ChakraLink } from '@chakra-ui/react';

const Contact = () => {
  return (
    <Stack
      w='full'
      minHeight='content-height'
      overflow='auto'
      paddingTop={{ base: '4', md: '10' }}
      paddingBottom={{ base: '6', md: '16' }}
      paddingInline={{ base: 0, md: '8', lg: '12' }}
    >
      <Box>
        <Heading as='h1' size='2xl' mb='6'>
          Contact
        </Heading>
      </Box>

      <SimpleGrid columns={{ base: 1, md: 3 }} gap={6}>
        <Box
          p={6}
          bg='white'
          borderRadius='md'
          border='1px solid'
          borderColor='gray.200'
          _hover={{ shadow: 'md' }}
        >
          <Heading as='h3' size='md' mb={4} fontWeight='bold'>
            Support Requests
          </Heading>
          <ChakraLink
            href='mailto:sksis_support@usask.ca'
            color='blue.600'
            fontWeight='bold'
            fontSize='sm'
            _hover={{ color: 'blue.800' }}
          >
            sksis_support@usask.ca
          </ChakraLink>
        </Box>

        <Box
          p={6}
          bg='white'
          borderRadius='md'
          border='1px solid'
          borderColor='gray.200'
          _hover={{ shadow: 'md' }}
        >
          <Heading as='h3' size='md' mb={4} fontWeight='bold'>
            User Agreement
          </Heading>
          <ChakraLink
            href='/SKSIS_User_Agreement.pdf'
            download
            color='blue.600'
            fontWeight='bold'
            fontSize='sm'
            _hover={{ color: 'blue.800' }}
          >
            Download
          </ChakraLink>
        </Box>

        <Box
          p={6}
          bg='white'
          borderRadius='md'
          border='1px solid'
          borderColor='gray.200'
          _hover={{ shadow: 'md' }}
        >
          <Heading as='h3' size='md' mb={4} fontWeight='bold'>
            User Evaluation Form
          </Heading>
          <ChakraLink
            href='https://docs.google.com/forms/d/e/1FAIpQLSfWIJq4ItGoLzZOOEF_dxnDCdJ7tQzVEEIpZuSWc6xh69JYTg/viewform?usp=sf_link'
            target='_blank'
            color='blue.600'
            fontWeight='bold'
            fontSize='sm'
            _hover={{ color: 'blue.800' }}
          >
            Open
          </ChakraLink>
        </Box>
      </SimpleGrid>
    </Stack>
  );
};

export default Contact;
